<template>
    <v-dialog v-model="dialog" max-width="990" v-resize="onResize"  persistent  @click:outside="outsideToCloseModal()">
        <v-card class="save-budget-modal pt-4 pb-4">
            <v-overlay color="#106c68" :value="loadingState" z-index="12" style="left: -57px;">
                <span class="loader"></span>
            </v-overlay>
            <v-form ref="saveBudgetForm" lazy-validation>
                <v-row no-gutters class="standard-row font-theme pb-1 pb-sm-10" align="center">
                    <v-col cols="12" sm="auto" md="auto" lg="auto" style="font-size: 16px; font-weight: 700;" class="text-center pl-sm-6">
                        บันทึกงบประมาณ
                    </v-col>
                    <v-col :cols="type_year_selected == 'ภายในปี'? 6:11" sm="3" md="2" lg="2" class="ml-2" justify="center">
                        <v-select v-if="selectedBiz.tax_id === '0107544000094'" class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="type_year_selected"
                        append-icon="mdi-chevron-down" :items="['ภายในปี','ข้ามปี']"
                        @change="changeYearSelect(year_selected_start)"
                        :disabled="(dataFromCreatePage.save_budget_id && !editDataMode) && true"
                        >
                        </v-select>
                        <v-select v-else class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="type_year_selected"
                        append-icon="mdi-chevron-down" :items="['ภายในปี','ข้ามปี']"
                        @change="changeYearSelect(year_selected_start)"
                        :disabled="(!editDataMode && saveBudgetId) && true"
                        >
                        </v-select>
                    </v-col>
                    <v-col :cols="5" sm="3" md="2" lg="2" class="ml-2 ml-sm-1 mb-1" :class="type_year_selected == 'ข้ามปี'? 'justify-space-between' : 'justify-center'">
                        <v-select v-if="selectedBiz.tax_id === '0107544000094'" class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="year_selected_start"
                        append-icon="mdi-chevron-down" :items="item_year.from"
                        @change="changeYearSelect($event)"
                        :disabled="(dataFromCreatePage.save_budget_id && !editDataMode) && true"
                        >
                        </v-select>
                        <v-select v-else class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="year_selected_start"
                        append-icon="mdi-chevron-down" :items="item_year.from"
                        @change="changeYearSelect($event)"
                        :disabled="(!editDataMode && saveBudgetId) && true"
                        >
                        </v-select>
                    </v-col>
                    <span v-if="type_year_selected == 'ข้ามปี'" class="ml-1">-</span>
                    <v-col v-if="type_year_selected == 'ข้ามปี'" :cols="5" sm="3" md="2" lg="2" class="ml-1 mb-1">
                        <v-select v-if="selectedBiz.tax_id === '0107544000094'" class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="year_selected_end"
                        append-icon="mdi-chevron-down" :items="item_year.to"
                        @change="!editDataMode && clearGroupBudget()"
                        :disabled="(dataFromCreatePage.save_budget_id && !editDataMode) && true"
                        >
                        </v-select>
                        <v-select v-else class="font-theme d-flex justify-center save-budget-dropdown-select-year" 
                        :menu-props="{ bottom: true, offsetY: true, contentClass: 'list-dropdown' }" 
                        dense hide-details height="29" color="black"
                        outlined v-model="year_selected_end"
                        append-icon="mdi-chevron-down" :items="item_year.to"
                        @change="!editDataMode && clearGroupBudget()"
                       :disabled="(!editDataMode && saveBudgetId) && true"
                        >
                        </v-select>
                    </v-col>
                    <!-- <v-col v-if="(saveBudgetData.from === 'run_po')" cols="auto" sm="auto" md="auto" lg="auto" class="pl-1 mt-3 mt-sm-0 d-flex justify-start">
                        <v-checkbox v-model="saveBudgetData.has_license" :true-value="true" :false-value="false" hide-details
                            color="grey" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline"
                            :ripple="false" class="mt-0 pt-0" density="compact" :disabled="(dataFromCreatePage.save_budget_id && !editDataMode) && true">
                            <template v-slot:label>
                                <span class="check-box-in-budget-save-budget-modal">License</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <v-spacer v-if="(saveBudgetData.has_license !== true)"></v-spacer>
                    <v-col v-if="saveBudgetData.from === 'run_po' && (saveBudgetData.has_license === true)" cols="auto" sm="auto" md="auto" lg="auto" class="pl-2 pb-1 mt-3 mt-sm-0">
                        <v-select v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" style="width: 154.60px;" :items="licenseDropdown"
                            height="29"  v-model="saveBudgetData.license" hide-details outlined dense
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }"
                            class="font-theme d-flex justify-center save-budget-dropdown-select-year"
                            required :rules="textRules">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">{{ data.item
                                        }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                        <v-text-field v-else height="24" color="black" hide-details readonly outlined  v-model="saveBudgetData.license" :rules="textRules" required class="text-box-save-budget-modal"></v-text-field>
                    </v-col> -->
                    <v-col cols="12" sm="auto" md="auto" lg="auto" class="pb-1 mt-3 mt-sm-0 pl-6 pl-sm-0 ml-sm-5 d-flex justify-end">
                        <v-radio-group v-if="selectedBiz.tax_id === '0107544000094'" class="mt-0 pt-0"  hide-details row v-model="saveBudgetData.in_off_budget" :disabled="(dataFromCreatePage.save_budget_id || dataFromCreatePage.document_status !== 'W')? true : false" :rules="[ v => v !== null && v !== undefined  ]" required>
                            <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-in-budget-save-budget-modal">ในงบประมาณ</span>
                                </template>
                            </v-radio>
                            <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-in-budget-save-budget-modal">นอกงบประมาณ</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                        <v-radio-group v-else class="mt-0 pt-0"  hide-details row v-model="saveBudgetData.in_off_budget" :disabled="((!editDataMode && saveBudgetId) || dataFromCreatePage.document_status !== 'W')? true : false" :rules="[ v => v !== null && v !== undefined  ]" required>
                            <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-in-budget-save-budget-modal">ในงบประมาณ</span>
                                </template>
                            </v-radio>
                            <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-in-budget-save-budget-modal">นอกงบประมาณ</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <div class="scroll-theme save-budget-modal-scroll">
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2" align="center">
                        <v-col cols="12" sm="6" md="4" lg="4" class="mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    งบประมาณปี
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined v-model="saveBudgetData.budget_start_year" :rules="textRules" required class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.budget_start_year" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mt-sm-0 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    ถึง
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined v-model="saveBudgetData.budget_end_year" :rules="textRules" required class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.budget_end_year" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mt-md-0">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    Type Budget
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id !== '0107544000094'" cols="7" sm="12" md="6" lg="6">
                                    <v-select v-if="unitItems.length !== 1 " :items="ListBudgetType" v-model="saveBudgetData.type_budget"  :rules="textRules" @change="getItemGroup()"
                                        hide-details outlined dense height="24" append-icon="mdi-chevron-down"
                                        item-color="#D9D9D9" color="black"
                                        class="pr-4 dropdown-external-save-budget-modal">
                                        <template v-slot:item="data">
                                            <v-list-item-content class="py-0">
                                                <v-list-item-title class="font-theme"
                                                    style="font-size: 13px; line-height: 30px;">{{ data.item }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content class="py-0">
                                                    <v-list-item-title class="font-theme"
                                                        style="font-size: 13px; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.type_budget" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                                <v-col v-else cols="7" sm="12" md="6" lg="6">
                                    <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined v-model="saveBudgetData.type_budget" :rules="textRules" required class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.type_budget" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    วันที่เริ่มต้น
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-menu v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W' && (saveBudgetData.from === 'save_cs_to_po' || saveBudgetData.from === 'run_po'))" :close-on-content-click="false" offset-y min-width="auto" v-model="dateMenu.start_date" transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field height="24" color="black" hide-details readonly outlined v-on="on" :value="startDateTextShow" :rules="textRules" required class="pr-4 text-box-save-budget-modal"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th" v-model="saveBudgetData.start_date" @input="dateMenu.start_date = false" :max="saveBudgetData?.end_date || new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" @change="calculateDateDiff()" class="font-theme date-picker-save-budget-modal"></v-date-picker>
                                    </v-menu>
                                    <!-- <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined readonly :value="startDateTextShow" class="pr-4 text-box-save-budget-modal"></v-text-field> -->
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly :value="saveBudgetData.start_date_show || startDateTextShow" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    วันที่สิ้นสุด
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-menu v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W' && (saveBudgetData.from === 'save_cs_to_po' || saveBudgetData.from === 'run_po'))" :close-on-content-click="false" offset-y min-width="auto" v-model="dateMenu.end_date" transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field height="24" color="black" hide-details readonly outlined v-on="on" :value="endDateTextShow" :rules="textRules" required class="pr-4 text-box-save-budget-modal"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th" v-model="saveBudgetData.end_date" @input="dateMenu.end_date = false" :min="saveBudgetData?.start_date || ''" @change="calculateDateDiff()" class="font-theme date-picker-save-budget-modal"></v-date-picker>
                                    </v-menu>
                                    <!-- <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined readonly :value="endDateTextShow" class="pr-4 text-box-save-budget-modal"></v-text-field> -->
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly :value="saveBudgetData.end_date_show || endDateTextShow" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mt-md-4">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    ระยะเวลาสัญญา
                                </v-col>
                                <v-col cols="6" xs="" sm="11" md="6" lg="6" class="mr-n3 mr-sm-n4 mr-md-n3">
                                    <v-text-field v-if="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" readonly :disabled="!(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W')" height="24" color="black" hide-details outlined v-model="saveBudgetData.contract_term" v-currency="{ distractionFree: false, currency: null, allowNegative: false, precision: 0 }" :rules="textRules" required class="pr-4 pr-sm-6 pr-md-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.contract_term" class="pr-4 pr-sm-6 pr-md-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                                <v-col cols="auto" sm="1" md="auto" lg="auto">
                                    วัน
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    ยอดเงิน PR
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.saved_budget" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    งบที่บันทึก
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field v-if="selectedBiz.tax_id === '0107544000094' && displayLicense === false" height="24" color="black" hide-details outlined readonly  v-model="saveBudgetData.net" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else-if="selectedBiz.tax_id === '0107544000094' && displayLicense === true" height="24" color="black" hide-details outlined readonly v-model="sumItemPrice" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="beforeSumItemPrice" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    ส่วนลด
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.discount" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mr-md-n6">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n6">
                                    มูลค่าสุทธิ
                                </v-col>
                                <v-col cols="7" sm="12" md="6" lg="6">
                                    <v-text-field v-if="selectedBiz.tax_id === '0107544000094' && displayLicense === false" height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.net" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else-if="selectedBiz.tax_id === '0107544000094' && displayLicense === true" height="24" color="black" hide-details outlined readonly v-model="sumItemPrice" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="sumItemPrice" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <!--------------------------------------------------- Product list --------------------------------------------------->
                    <v-row no-gutters class="standard-row font-theme my-5 px-4" align="center">
                        <v-row no-gutters class="standard-row font-theme pb-3" align="center" style="border: 1px solid #A8A8A8; border-radius: 18px;">
                            <v-row no-gutters v-for="(product, index) in saveBudgetData.item" :key="`${product.item_id}_${index}`" class="standard-row font-theme mt-3 mx-3" align="center">
                                <v-col cols="12" sm="12" md="2" lg="2" class="d-flex justify-center mr-md-2 item-group-budget-list-save-budget-modal name-first-item-header-save-budget-modal">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="font-theme text-center px-2 px-md-1" v-on="on" v-bind="attrs">{{ windowSize.x > 960? cutItemName(product.item_name) : product?.item_name }}</span>
                                        </template>
                                        <span class="font-theme">{{ product?.item_name }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id === '0107544000094'" cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!dataFromCreatePage.save_budget_id && !dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[0].group?.group_name? false : true) : ((product.group?.length >= 1 && product.group[0].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[0]?.dropdown_list" v-model="product.group[0].group" @change="getGroupBudget(1, product.group[0].group.group_id, index)" :loading="product.group[0]?.loading_status" v-on="on" v-bind="attrs" placeholder="Group" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[ v => !!v && !!v.group_id && !!v.group_name ]" required class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 1? product.group[0].group_name : null" placeholder="Group" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[0].group?.group_name) : (product.group?.length? product.group[0].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-else cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!saveBudgetStatus && !saveBudgetStatus && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !saveBudgetStatus)? (product.group[0].group?.group_name? false : true) : ((product.group?.length >= 1 && product.group[0].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !saveBudgetId) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[0]?.dropdown_list" v-model="product.group[0].group" @change="getGroupBudget(1, product.group[0].group.group_id, index)" :loading="product.group[0]?.loading_status" v-on="on" v-bind="attrs" placeholder="Group" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[ v => !!v && !!v.group_id && !!v.group_name ]" required class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 1? product.group[0].group_name : null" placeholder="Group" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!saveBudgetId && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !saveBudgetId)? (product.group[0].group?.group_name) : (product.group?.length? product.group[0].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id === '0107544000094'" cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[1].group?.group_name? false : true) : ((product.group?.length >= 2 && product.group[1].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[1]?.dropdown_list" v-model="product.group[1].group" @input="getGroupBudget(2, product.group[1].group.group_id, index)" :loading="product.group[1]?.loading_status" :disabled="(product.group[0]?.group?.group_id && !product.group[1]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 1" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[1]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 2? product.group[1].group_name : null" placeholder="Sub 1" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[1].group?.group_name) : (product.group?.length >= 2? product.group[1].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-else cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!saveBudgetId && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !saveBudgetId)? (product.group[1].group?.group_name? false : true) : ((product.group?.length >= 2 && product.group[1].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !saveBudgetId) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[1]?.dropdown_list" v-model="product.group[1].group" @input="getGroupBudget(2, product.group[1].group.group_id, index)" :loading="product.group[1]?.loading_status" :disabled="(product.group[0]?.group?.group_id && !product.group[1]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 1" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[1]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 2? product.group[1].group_name : null" placeholder="Sub 1" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!saveBudgetId && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !saveBudgetId)? (product.group[1].group?.group_name) : (product.group?.length >= 2? product.group[1].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id === '0107544000094'" cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[2].group?.group_name? false : true) : ((product.group?.length >= 3 && product.group[2].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[2]?.dropdown_list" v-model="product.group[2].group" @change="getGroupBudget(3, product.group[2].group.group_id, index)" :loading="product.group[2]?.loading_status" :disabled="(product.group[1]?.group?.group_id && !product.group[2]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 2" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[2]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 3? product.group[2].group_name : null" placeholder="Sub 2" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode)? (product.group[2].group?.group_name) : (product.group?.length >= 3? product.group[2].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-else cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!saveBudgetId && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !saveBudgetId)? (product.group[2].group?.group_name? false : true) : ((product.group?.length >= 3 && product.group[2].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !saveBudgetId) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[2]?.dropdown_list" v-model="product.group[2].group" @change="getGroupBudget(3, product.group[2].group.group_id, index)" :loading="product.group[2]?.loading_status" :disabled="(product.group[1]?.group?.group_id && !product.group[2]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 2" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[2]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 3? product.group[2].group_name : null" placeholder="Sub 2" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!saveBudgetId && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode)? (product.group[2].group?.group_name) : (product.group?.length >= 3? product.group[2].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id === '0107544000094'" cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[3].group?.group_name? false : true) : ((product.group?.length >= 4 && product.group[3].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[3]?.dropdown_list" v-model="product.group[3].group" item-text="group_name" :loading="product.group[3]?.loading_status" :disabled="(product.group[2]?.group?.group_id && !product.group[3]?.loading_status)? false : true" v-on="on" v-bind="attrs" height="28" append-icon="mdi-chevron-down" placeholder="Sub 3" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[3]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 4? product.group[3].group_name : null" placeholder="Sub 3" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !dataFromCreatePage.save_budget_id)? (product.group[3].group?.group_name) : (product.group?.length >= 4? product.group[3].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-else cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip v-if="isReady" top :disabled="(!saveBudgetId && dataFromCreatePage.document_status !== 'W')? true : ((editDataMode || !saveBudgetId)? (product.group[3].group?.group_name? false : true) : ((product.group?.length >= 4 && product.group[3].group_name)? false : true))">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete v-if="((editDataMode || !saveBudgetId) && dataFromCreatePage.document_status === 'W')" hide-details outlined dense :items="product?.group[3]?.dropdown_list" v-model="product.group[3].group" item-text="group_name" :loading="product.group[3]?.loading_status" :disabled="(product.group[2]?.group?.group_id && !product.group[3]?.loading_status)? false : true" v-on="on" v-bind="attrs" height="28" append-icon="mdi-chevron-down" placeholder="Sub 3" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[3]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-text-field v-else height="28" color="black" hide-details outlined readonly v-on="on" v-bind="attrs" :value="product.group?.length >= 4? product.group[3].group_name : null" placeholder="Sub 3" class="pr-md-6 text-box-group-save-budget-modal"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ (!saveBudgetId && dataFromCreatePage.document_status !== 'W')? null : ((editDataMode || !saveBudgetId)? (product.group[3].group?.group_name) : (product.group?.length >= 4? product.group[3].group_name : null)) }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id === '0107544000094'" cols="10" sm="" md="2" lg="2" class="d-flex justify-center item-group-budget-list-save-budget-modal mt-3 mt-md-0 name-last-item-header-save-budget-modal">
                                    {{ product?.net ? addComma(Number(product?.net?.replace(/,/g, '')).toFixed(2)) : null}}
                                </v-col>
                                <v-col v-else cols="10" sm="" md="2" lg="2" class="d-flex justify-center item-group-budget-list-save-budget-modal mt-3 mt-md-0 name-last-item-header-save-budget-modal">
                                    {{ product?.total_product_price ? addComma(Number(product?.total_product_price?.replace(/,/g, '')).toFixed(2)) : null}}
                                </v-col>
                                <v-col cols="2" sm="auto" md="" lg="" class="d-flex justify-center mt-3 mt-md-0 pl-3 pl-md-0">
                                <v-btn
                                    color="#0B68D6"
                                    width="44"
                                    height="28"
                                    class="calendar-btn-save-budget-modal"
                                    :class="{
                                        'calendar-btn-error':
                                            dataFromCreatePage.document_status === 'W' &&
                                            isSubmitted &&
                                            saveBudgetData.item[index].is_plan_empty !== 'isPlanEmpty',

                                        'calendar-btn-success':
                                            dataFromCreatePage.document_status === 'W' &&
                                            saveBudgetData.item[index].is_plan_empty === 'isPlanEmpty'
                                    }"
                                    @click="openPlanSaveBudgetModal(product, index)"
                                    >
                                    <img src="../assets/icon-calendar.png"
                                        contain style="height: 18px" />
                                </v-btn>
                                </v-col>
                            </v-row>
                        </v-row>
                    </v-row>
                    <v-row
                    v-if="displayLicense === true"
                    no-gutters
                    align="center"
                    class="standard-row font-theme pl-6 pr-2"
                    >
                    <!-- ================= License checkbox ================= -->
                    <v-col
                        cols="12" sm="2" md="2" lg="2" 
                        class="mb-3 d-flex align-center"
                    >
                        <v-checkbox
                        v-model="saveBudgetData.has_license"
                        hide-details
                        density="compact"
                        color="grey"
                        :ripple="false"
                        class="mt-0 pt-0"
                        :disabled="dataFromCreatePage.save_budget_id && !editDataMode"
                        >
                        <template #label>
                            <span class="check-box-in-budget-save-budget-modal">
                            License
                            </span>
                        </template>
                        </v-checkbox>
                    </v-col>

                    <!-- ================= License dropdown ================= -->
                    <v-col
                        v-if="saveBudgetData.has_license"
                        cols="12" sm="3" md="3" lg="3" 
                        class="mb-3"
                    >
                        <v-select
                        v-if="
                            (editDataMode || !dataFromCreatePage.save_budget_id) &&
                            dataFromCreatePage.document_status === 'W'
                        "
                        v-model="saveBudgetData.license"
                        :items="licenseDropdown"
                        outlined
                        dense
                        hide-details
                        height="24"
                        item-color="#D9D9D9"
                        color="black"
                        append-icon="mdi-chevron-down"
                        class="pr-4 dropdown-external-cost-save-budget-modal"
                        />

                        <v-text-field
                        v-else
                        v-model="saveBudgetData.license"
                         outlined
                        hide-details
                        height="24"
                        color="black"
                        readonly
                        class="pr-4 text-box-save-budget-modal"
                        />
                    </v-col>

                    <!-- ================= Renew checkbox ================= -->
                    <v-col
                        v-if="
                        (saveBudgetData.license === 'Palo' ||
                        saveBudgetData.license === 'Fortigate')
                        && saveBudgetData.has_license === true"
                        cols="12" sm="2" md="2" lg="2" 
                        class="mb-3 d-flex align-center"
                    >
                        <v-checkbox
                        v-model="saveBudgetData.renew"
                        hide-details
                        density="compact"
                        color="grey"
                        :ripple="false"
                        class="mt-0 pt-0"
                        :disabled="dataFromCreatePage.save_budget_id && !editDataMode"
                        >
                        <template #label>
                            <span class="check-box-in-budget-save-budget-modal">
                            Renew
                            </span>
                        </template>
                        </v-checkbox>
                    </v-col>
                    <!-- ================= Serial Number ================= -->
                    <v-col
                        v-if="(saveBudgetData.license === 'Palo' ||
                        saveBudgetData.license === 'Fortigate')
                        && saveBudgetData.has_license === true && saveBudgetData.renew === true"
                        cols="12" sm="3" md="3" lg="3" 
                        class="mb-3"
                    >
                        <v-text-field  v-if="
                            (editDataMode || !dataFromCreatePage.save_budget_id) &&
                            dataFromCreatePage.document_status === 'W'
                        "
                        v-model="saveBudgetData.serial_number"
                        outlined
                        hide-details
                        height="24"
                        color="black"
                        class="pr-4 text-box-save-budget-modal"
                        placeholder="S/N (Serial Number)"
                        :rules="textRules"
                        required
                        />
                        <v-text-field  v-else
                        v-model="saveBudgetData.serial_number"
                        outlined
                        hide-details
                        height="24"
                        color="black"
                        readonly
                        class="pr-4 text-box-save-budget-modal"
                        placeholder="S/N (Serial Number)"
                        />
                        
                    </v-col>
                    <v-col
                        v-else-if="(saveBudgetData.license === 'Sophos'
                        && saveBudgetData.has_license === true)"
                        cols="12" sm="3" md="3" lg="3" 
                        class="mb-3"
                    >
                        <v-text-field  v-if="
                            (editDataMode || !dataFromCreatePage.save_budget_id) &&
                            dataFromCreatePage.document_status === 'W'
                        "
                        v-model="saveBudgetData.serial_number"
                        outlined
                        hide-details
                        height="24"
                        color="black"
                        class="pr-4 text-box-save-budget-modal"
                        placeholder="S/N (Serial Number)"
                        :rules="textRules"
                        required
                        />
                        <v-text-field  v-else
                        v-model="saveBudgetData.serial_number"
                        outlined
                        hide-details
                        height="24"
                        color="black"
                        readonly
                        class="pr-4 text-box-save-budget-modal"
                        placeholder="S/N (Serial Number)"
                        />
                        
                    </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2" align="center">
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 13px;" class="mr-md-n3">
                                    External Cost to 
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id !== '0107544000094'" cols="7" sm="12" md="6" lg="6">
                                    <v-select v-if="((editDataMode || !saveBudgetId) && dataFromCreatePage.document_status === 'W')" :items="dropdownListItem.external_cost_to" v-model="saveBudgetData.external_cost_to" :filled="(!editDataMode && saveBudgetId)? true : false" :readonly="(!editDataMode && saveBudgetId)? true : false" hide-details outlined dense height="24" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object class="pr-4 dropdown-external-cost-save-budget-modal">
                                        <template v-slot:item="data">
                                            <v-list-item-content class="py-0">
                                                <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 30px;">{{ data.item }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content class="py-0">
                                                    <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.external_cost_to" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                                <v-col v-else cols="7" sm="12" md="6" lg="6">
                                    <v-select v-if="((editDataMode || !dataFromCreatePage.save_budget_id) && dataFromCreatePage.document_status === 'W')" :items="dropdownListItem.external_cost_to" v-model="saveBudgetData.external_cost_to" :filled="(!editDataMode && dataFromCreatePage.save_budget_id)? true : false" :readonly="(!editDataMode && dataFromCreatePage.save_budget_id)? true : false" hide-details outlined dense height="24" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object class="pr-4 dropdown-external-cost-save-budget-modal">
                                        <template v-slot:item="data">
                                            <v-list-item-content class="py-0">
                                                <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 30px;">{{ data.item }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content class="py-0">
                                                    <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                    <v-text-field v-else height="24" color="black" hide-details outlined readonly v-model="saveBudgetData.external_cost_to" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mt-sm-0 mr-md-n7">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n12">
                                    Sub team
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id !== '0107544000094'" cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined :readonly="((!editDataMode && saveBudgetId) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.sub_team" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                                <v-col v-else cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined :readonly="((!editDataMode && dataFromCreatePage.save_budget_id) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.sub_team" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="mt-3 mt-md-0 mr-md-n10">
                            <v-row no-gutters class="standard-row font-theme" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px;" class="mr-md-n12">
                                    Ref.PO
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id !== '0107544000094'" cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined :readonly="((!editDataMode && saveBudgetId) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.ref_po" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                                <v-col v-else cols="7" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined :readonly="((!editDataMode && dataFromCreatePage.save_budget_id) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.ref_po" class="pr-4 text-box-save-budget-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2" align="center">
                        <v-col cols="12" sm="12" md="12" lg="12" class="mt-3 mr-md-n3">
                            <v-row no-gutters class="standard-row font-theme">
                                <v-col cols="5" sm="12" md="2" lg="2" style="font-size: 14px;" class="mr-md-n3">
                                    Remark
                                </v-col>
                                <v-col v-if="selectedBiz.tax_id !== '0107544000094'" cols="7" sm="12" md="8" lg="8">
                                    <v-textarea hide-details outlined rows="3" color="black" :readonly="((!editDataMode && saveBudgetId) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.remark" class="pr-4 pr-md-0 pr-lg-4 remark-textarea-save-budget-modal"></v-textarea>
                                </v-col>
                                <v-col v-else cols="7" sm="12" md="8" lg="8">
                                    <v-textarea hide-details outlined rows="3" color="black" :readonly="((!editDataMode && dataFromCreatePage.save_budget_id) || dataFromCreatePage.document_status !== 'W')? true : false" v-model="saveBudgetData.remark" class="pr-4 pr-md-0 pr-lg-4 remark-textarea-save-budget-modal"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-row  v-if="selectedBiz.tax_id === '0107544000094'" no-gutters class="standard-row font-theme mt-6 pr-7 d-flex justify-end" align="center">
                    <v-btn :disabled="!disabledBtnBudget" v-if="dataFromCreatePage.save_budget_id && dataFromCreatePage.document_status === 'W'" @click="editGroupData()" height="32" width="74" :color="editDataMode? '#8B0000' : '#F20606'" style="box-shadow: none; color: white; border-radius: 5px; font-weight: 600; font-size: 16px; letter-spacing: 0.1px; margin-right: 14px;">
                        แก้ไข
                    </v-btn>
                    <v-btn :disabled="!disabledBtnBudget"  height="32" width="74" color="#0B68D6" @click="confirmAddSaveBudget()" :loading="loadingAddSaveBudget" style="box-shadow: none; color: white; border-radius: 5px; font-weight: 600; font-size: 16px; letter-spacing: 0.1px;">
                        ยืนยัน
                    </v-btn>
                </v-row>
                <v-row  v-else no-gutters class="standard-row font-theme mt-6 pr-7 d-flex justify-end" align="center">
                    <v-btn :disabled="!disabledBtnBudget" v-if="saveBudgetStatus && dataFromCreatePage.document_status === 'W'" @click="editGroupData()" height="32" width="74" :color="editDataMode? '#8B0000' : '#F20606'" style="box-shadow: none; color: white; border-radius: 5px; font-weight: 600; font-size: 16px; letter-spacing: 0.1px; margin-right: 14px;">
                        แก้ไข
                    </v-btn>
                    <v-btn :disabled="!disabledBtnBudget"  height="32" width="74" color="#0B68D6" @click="confirmAddSaveBudget()" :loading="loadingAddSaveBudget" style="box-shadow: none; color: white; border-radius: 5px; font-weight: 600; font-size: 16px; letter-spacing: 0.1px;">
                        ยืนยัน
                    </v-btn>
                </v-row>
            </v-form>
            <PlanSaveBudgetModal />
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import PlanSaveBudgetModal from '../components/PlanSaveBudgetModal.vue'
export default {
    components: {
        PlanSaveBudgetModal
    },
    data: () => ({
        displayLicense: true,
        dialog: false,
        disabledBtnBudget: true,
        callApiPending: 0,
        saveBudgetData: {},
        editDataMode: false,
        loadingState: false,
        allGroupBudget: null,
        windowSize: { x: 0 },
        propsForClearData: {},
        dataFromCreatePage: {},
        textRules: [ v => !!v ],
        loadingAddSaveBudget: false,
        filteredProductItems:[],
        unitItems:[],
        saveBudgetStatus: false,
        saveBudgetId:'',
        isSubmitted: false,
        saveBudgetEmptyData: {
            "item": null,
            "ref_po": null,
            "remark": null,
            "tax_id": null,
            "sub_team": null,
            "end_date": null,
            "start_date": null,
            "type_budget": null,
            "saved_budget": null,
            "total_budget": null,
            "in_off_budget": null,
            "contract_term": null,
            "save_budget_id": null,
            "total_price": null,
            "total_discount": null,
            "transaction_id": null,
            "budget_end_year": null,
            "external_cost_to": null,
            "budget_start_year": null,
            "discount": null,
            "net": null
        },
        dropdownListItem: {
            "group_budget"     : [],
            "sub_group1"       : [],
            "sub_group2"       : [],
            "sub_group3"       : [],
            "external_cost_to" : ["External", "Internal"]
        },
        dateMenu: {
            "start_date": false,
            "end_date": false
        },
        isReady: true,
        beforeSumItemPrice:'',
        sumItemPrice:'',
        isProductsDiscount: false,
        documentYear: null,
        type_year_selected: 'ภายในปี',
        year_selected_start: null,
        year_selected_end: null,
        ListBudgetType:[],
        has_license:false,
        licenseDropdown : [
        'Acronis',
        'cPanel',
        'DirectAdmin',
        'DUO',
        'EPP/EDR Licenses',
        'Fortigate',
        'OPNsense',
        'Other License',
        'Palo',
        'Plesk',
        'RDS Easy D',
        'Sophos',
        'SPLA',
        'SUSE',
        'VCPP',
        'Veeam',
        ],
        item_year: {
            from: [],
            to: []
        }
    }),
    mounted() {
        this.onResize()
        this.getYearList()
        EventBus.$on('openSaveBudgetStatus', (data) => {
            this.saveBudgetStatus = data;
        });
        EventBus.$on('openSaveBudgetModal', this.openDialog)
        EventBus.$on('afterPlanSaveBudget', this.updatePlanBudget)
    },
    computed: {
        startDateTextShow() {
            return MainFunction.shortDate(this.saveBudgetData.start_date || null)
        },
        endDateTextShow() {
            return MainFunction.shortDate(this.saveBudgetData.end_date || null)
        },
        // setGetBudgetType () {
        //         return this.$store.state.budgetType.map(e => ({ type: e.type.toUpperCase()}));
        // },
        setDataProducts () {
                return this.$store.state.dataProducts;
        },
        selectedBiz() {
                return this.$store.state.confirmSelectedBiz
        },
    },
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.saveBudgetData = {}
                this.editDataMode   = false
                this.allGroupBudget = null
                this.isSubmitted = false
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        },
        'saveBudgetData.has_license'(val, oldVal) {
            if (oldVal === true && val === false) {
            this.saveBudgetData.license = ''
            this.saveBudgetData.renew = false
            this.saveBudgetData.serial_number= ''
            }
        },

        'saveBudgetData.license'(val, oldVal) {
            if (
            oldVal &&
            !['Palo', 'Fortigate'].includes(val)
            ) {
            this.saveBudgetData.renew = false
            this.saveBudgetData.serial_number= ''
            }
        },

        'saveBudgetData.renew'(val, oldVal) {
            if (oldVal === true && val === false) {
            this.saveBudgetData.serial_number= ''
            }
        }
    },
    beforeDestroy() {
        EventBus.$off('openSaveBudgetStatus')
        EventBus.$off('openSaveBudgetModal')
        EventBus.$off('afterPlanSaveBudget')
    },
    methods: {
        openDialog(data) {
            this.displayLicense = data.from === 'purchase_detail' ? false : true
            this.setTypeBudget = data.products.map(e => e.cut_budget_type);
            this.getBudgetType()
            if (this.selectedBiz.tax_id === '0107544000094') {
                if (data.save_budget_id) {
                    this.dataFromCreatePage = data
                    this.saveBudgetData.item = data.products
                    this.saveBudget = data.save_budget
                    this.getSaveBudgetDetail(data.save_budget_id)
                    this.documentYear = data.document_year
                } else if (!data.save_budget_id && data.document_status === 'W') {
                    this.$refs.saveBudgetForm?.resetValidation()
                    this.saveBudgetData = structuredClone(this.saveBudgetEmptyData)
                    this.saveBudgetData.type_budget = data.type_budget || null
                    this.saveBudgetData.tax_id = data.tax_id || null
                    this.saveBudgetData.transaction_id = data.transaction_id || null
                    if(data.from === 'purchase_detail'){
                        this.saveBudgetData.saved_budget = MainFunction.addComma(Number(String(data.products?.reduce((total, current) => total + Number(current.total_product_price?.replace(/,/g, '') || 0), 0) || 0).replace(/,/g, '')).toFixed(2));
                    }else{
                        this.saveBudgetData.saved_budget = MainFunction.addComma(Number(String(data.total_price || 0).replace(/,/g, '')).toFixed(2));
                    }
                    this.saveBudgetData.in_off_budget = typeof data.in_budget === 'boolean' ? data.in_budget : null
                    this.saveBudgetData.budget_start_year = (Number(data.start_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
                    this.saveBudgetData.budget_end_year = (Number(data.end_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
                    this.saveBudgetData.start_date = data.start_date || null
                    this.saveBudgetData.end_date = data.end_date || null
                    this.saveBudgetData.item = data.products
                    this.saveBudget = data.save_budget
                    this.saveBudgetData.from = data.from || data.formData || null

                    this.dataFromCreatePage = data
                    this.saveBudgetData.total_price = MainFunction.addComma(data.total_price?.replace(/,/g, '') || '0')
                    this.saveBudgetData.discount = MainFunction.addComma(
                        (data.products || [])
                            .reduce((total, current) => {
                                return total + Number(
                                    current.discount?.replace(/,/g, '') || 0
                                );
                            }, 0)
                            .toFixed(2)
                    );

                    const savedBudget = Number(
                        this.saveBudgetData.saved_budget?.replace(/,/g, '') || 0
                    );

                    const discount = Number(
                        this.saveBudgetData.discount?.replace(/,/g, '') || 0
                    );

                    this.saveBudgetData.net = MainFunction.addComma(
                        (savedBudget - discount).toFixed(2)
                    );

                    const budget = Number(
                        (
                            this.saveBudgetData.total_price ||
                            this.saveBudgetData.saved_budget ||
                            0
                        ).toString().replace(/,/g, '')
                    );

                    this.sumItemPrice = this.saveBudgetData.saved_budget
                        ? MainFunction.addComma(
                            (budget - discount).toFixed(2)
                        )
                        : null;
                    this.getGroupBudget(0)
                    this.calculateDateDiff()
                    this.dialog = true
                } else {
                    this.$refs.saveBudgetForm?.resetValidation()
                    this.saveBudgetData = structuredClone(this.saveBudgetEmptyData)
                    this.saveBudgetData.item = data.products
                    this.saveBudget = data.save_budget
                    this.dataFromCreatePage = data
                    this.dialog = true
                    this.$forceUpdate()
                }
            } else {
                // this.$store.commit('setDataProducts', data.products)
                if (this.saveBudgetStatus) {
                    this.dataFromCreatePage = data
                    this.saveBudgetData.item = data.products
                    this.copyDataProducts = data.products
                    this.saveBudget = data.save_budget
                    this.documentYear = data.document_year
                    this.saveBudgetData.type_budget = data.type_budget || null
                    this.saveBudgetData.discount = Number(this.saveBudgetData.discount?.replace(/,/g, '') || '0').toFixed(2);
                    this.documentYear = data.document_year ? data.document_year : new Date().getFullYear()
                    this.unitItems = [...new Set(this.saveBudgetData.item.map(e => e.cut_budget_type.trim()))] || null
                    let firstCutBudgetType = '';
                    if (this.saveBudgetData.type_budget == 'SGA') {
                        firstCutBudgetType = 'ค่าใช้จ่ายขายและบริการ (SG&A)'
                    } else if (this.saveBudgetData.type_budget == 'COST') {
                        firstCutBudgetType = 'ต้นทุนขาย (COGS)'
                    } else {
                        firstCutBudgetType = 'ต้นทุนวิจัยและพัฒนา (R&D)'
                    }
                    let beforeSumItemPrice = this.saveBudgetData.item
                        .filter(e => e.cut_budget_type === firstCutBudgetType)
                        .reduce((sum, e) => sum + parseFloat(e.total_product_price.replace(/,/g, '')), 0);
                    this.sumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice - parseFloat((this.saveBudgetData.discount || '0').toString().replace(/,/g, ''))).toFixed(2));
                    this.beforeSumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice || '0').toFixed(2));
                    this.getItemGroup()
                } else if (!this.saveBudgetStatus && data.document_status === 'W') {
                    this.$refs.saveBudgetForm?.resetValidation()
                    this.saveBudgetData = structuredClone(this.saveBudgetEmptyData)
                    this.saveBudgetData.type_budget = data.type_budget || null
                    this.saveBudgetData.tax_id = data.tax_id || null
                    this.saveBudgetData.transaction_id = data.transaction_id || null
                    this.saveBudgetData.saved_budget = MainFunction.addComma(data.products.reduce((total, current) => {
                        const total_budget = Number(data.total_price?.replace(/,/g, '') || '0');
                        const currencyExchange = Number(current.currency_exchange?.replace(/,/g, '') || '1');
                        return total_budget * currencyExchange;
                    }, 0).toFixed(2));
                    this.saveBudgetData.in_off_budget = typeof data.in_budget === 'boolean' ? data.in_budget : null
                    this.saveBudgetData.budget_start_year = (Number(data.start_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
                    this.saveBudgetData.budget_end_year = (Number(data.end_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
                    this.saveBudgetData.start_date = data.start_date || null
                    this.saveBudgetData.end_date = data.end_date || null
                    this.saveBudgetData.item = data.products
                    this.copyDataProducts = data.products || null
                    this.unitItems = [...new Set(this.saveBudgetData.item.map(e => e.cut_budget_type.trim()))] || null
                    this.saveBudget = data.save_budget
                    this.saveBudgetData.from = data.from || data.formData || null

                    this.dataFromCreatePage = data

                    this.saveBudgetData.saved_budget = MainFunction.addComma(data.products.reduce((total, current) => {
                        const totalPrice = Number(current.total_product_price?.replace(/,/g, '') || '0');
                        const currencyExchange = Number(current.currency_exchange?.replace(/,/g, '') || '1');
                        return total + totalPrice * currencyExchange;
                    }, 0).toFixed(2));
                    this.saveBudgetData.discount = MainFunction.addComma(data.products.reduce((total, current) => {
                        const discount = Number(current.discount?.replace(/,/g, '') || '0')
                        const currencyExchange = Number(current.currency_exchange?.replace(/,/g, '') || '1');
                        return total + (discount * currencyExchange)
                    }, 0).toFixed(2));
                        const budget = Number(this.saveBudgetData.saved_budget?.toString().replace(/,/g, '')) || 0;
                        const discount = Number(this.saveBudgetData.discount?.toString().replace(/,/g, '')) || 0;
                        const netResult = discount > 0 ? (budget - discount) : budget;
                    this.saveBudgetData.net = MainFunction.addComma(netResult.toFixed(2));
                    this.documentYear = data.document_year ? data.document_year : new Date().getFullYear()
                    let firstCutBudgetType = '';
                    if (this.saveBudgetData.type_budget == 'SGA') {
                        firstCutBudgetType = 'ค่าใช้จ่ายขายและบริการ (SG&A)'
                    } else if (this.saveBudgetData.type_budget == 'COST') {
                        firstCutBudgetType = 'ต้นทุนขาย (COGS)'
                    } else {
                        firstCutBudgetType = 'ต้นทุนวิจัยและพัฒนา (R&D)'
                    }
                    let beforeSumItemPrice = this.saveBudgetData.item
                        .filter(e => e.cut_budget_type === firstCutBudgetType)
                        .reduce((sum, e) => sum + parseFloat(e.total_product_price.replace(/,/g, '')), 0);
                    this.sumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice - parseFloat((this.saveBudgetData.discount || '0').toString().replace(/,/g, ''))).toFixed(2));
                    this.beforeSumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice || '0').toFixed(2));
                    this.getItemGroup()
                    this.calculateDateDiff()
                    this.dialog = true
                } else {
                    this.dataFromCreatePage = data
                    this.saveBudgetData.item = data.products
                    this.copyDataProducts = data.products
                    this.saveBudget = data.save_budget
                    this.documentYear = data.document_year
                    this.saveBudgetData.type_budget = data.type_budget || null
                    this.saveBudgetData.discount = Number(this.saveBudgetData.discount?.replace(/,/g, '') || '0').toFixed(2);
                    this.documentYear = data.document_year ? data.document_year : new Date().getFullYear()
                    this.unitItems = [...new Set(this.saveBudgetData.item.map(e => e.cut_budget_type.trim()))] || null
                    let firstCutBudgetType = '';
                    if (this.saveBudgetData.type_budget == 'SGA') {
                        firstCutBudgetType = 'ค่าใช้จ่ายขายและบริการ (SG&A)'
                    } else if (this.saveBudgetData.type_budget == 'COST') {
                        firstCutBudgetType = 'ต้นทุนขาย (COGS)'
                    } else {
                        firstCutBudgetType = 'ต้นทุนวิจัยและพัฒนา (R&D)'
                    }
                    let beforeSumItemPrice = this.saveBudgetData.item
                        .filter(e => e.cut_budget_type === firstCutBudgetType)
                        .reduce((sum, e) => sum + parseFloat(e.total_product_price.replace(/,/g, '')), 0);
                    this.sumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice - parseFloat((this.saveBudgetData.discount || '0').toString().replace(/,/g, ''))).toFixed(2));
                    this.beforeSumItemPrice = MainFunction.addComma(Number(beforeSumItemPrice || '0').toFixed(2));
                    this.getItemGroup()
                }
            }
            this.isProductsDiscount = data.products.some(e => e.discount && (Number(e.discount?.replace(/,/g, '') || '0') > 0)) ? true : false
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        async getSaveBudgetDetail(save_budget_id) {
            if (!save_budget_id) {
                return
            }
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/save_budget/api/v1/save_budget_detail?save_budget_id=${save_budget_id}`)
                if (data.status && Object.keys(data.data).length) {
                    this.saveBudgetData                   = data.data
                    this.dataFromCreatePage.item          = structuredClone(data.data.item)
                    this.saveBudgetData.start_date_show   = MainFunction.shortDate(data.data.start_date) || null
                    this.saveBudgetData.end_date_show     = MainFunction.shortDate(data.data.end_date)   || null
                    this.saveBudgetData.budget_start_year = (Number(data.data.budget_start_year) + 543)  || null
                    this.saveBudgetData.budget_end_year   = (Number(data.data.budget_end_year) + 543)    || null
                    this.saveBudgetData.total_budget      = MainFunction.addComma(data.data.total_budget ? data.data.total_budget : '0.00')
                    this.saveBudgetData.saved_budget      = MainFunction.addComma(data.data.saved_budget ? data.data.saved_budget  : '0.00')
                    this.saveBudgetData.discount          = MainFunction.addComma(data.data.discount === undefined || data.data.discount === null ? '0.00' : data.data.discount || null)
                    this.saveBudgetData.net               = MainFunction.addComma(data.data.net === undefined || data.data.net === null ? data.data.saved_budget : data.data.net || null)
                    this.type_year_selected               = this.saveBudgetData.budget_year_type         || 'ภายในปี'
                    this.year_selected_start              = this.saveBudgetData.group_first_year ? String(this.saveBudgetData.group_first_year) : this.documentYear
                    this.year_selected_end                = this.saveBudgetData.group_last_year  ? String(this.saveBudgetData.group_last_year) : this.documentYear
                    
                    if(this.selectedBiz.tax_id !== '0107544000094'){
                    this.saveBudgetData.external_cost_to = data.data.external_cost_to
                    this.saveBudgetData.sub_team = data.data.sub_team
                    this.saveBudgetData.ref_po   = data.data.ref_po
                    this.saveBudgetData.remark = data.data.remark
                    }
        
                    for (let i = 0; i < data.data.item.length; i++) {
                        this.saveBudgetData.item[i].total_product_price = MainFunction.addComma(Number(data.data.item[i].item_price || '0'))
                        this.saveBudgetData.item[i].net = this.saveBudgetData.item[i].net === undefined || this.saveBudgetData.item[i].net === null ? this.saveBudgetData.item[i].total_product_price : MainFunction.addComma(Number(data.data.item[i].net || '0'))
                        this.saveBudgetData.item[i].discount = MainFunction.addComma(Number(data.data.item[i].discount || '0').toFixed(2))
                        for (let j = 0; j < 4; j++) {
                            if (!this.saveBudgetData.item[i].group[j]) {
                                this.saveBudgetData.item[i].group[j] = {
                                    "level"          : j,
                                    "dropdown_list"  : [],
                                    "group"          : null,
                                    "group_id"       : null,
                                    "group_name"     : null,
                                    "loading_status" : false
                                }
                            }
                        }
                    }
                    this.dialog = true
                }
            } catch (error) {
                this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                console.log(error);
            } finally {
                this.getSumItemPrice()
                this.disabledBtnBudget  = true;
                this.callApiPending--
            }
        },
        getItemGroup(){
            this.saveBudgetData.item = this.copyDataProducts
            const CutBudgetType = this.saveBudgetData.type_budget;
                let firstCutBudgetType = '';
                if(CutBudgetType == 'SGA'){
                    firstCutBudgetType = 'ค่าใช้จ่ายขายและบริการ (SG&A)'
                }else if (CutBudgetType == 'COST') {
                    firstCutBudgetType = 'ต้นทุนขาย (COGS)'
                } else {
                    firstCutBudgetType = 'ต้นทุนวิจัยและพัฒนา (R&D)'
                    
                }

                let filteredProductItems = this.saveBudgetData.item.filter(e => 
                    e.cut_budget_type == firstCutBudgetType
                );
                this.saveBudgetData.item = filteredProductItems;
            this.editDataMode = false;
            this.disabledBtnBudget  = false;
            if((this.editDataMode || !this.saveBudgetId) || (this.dataFromCreatePage.document_status === 'W' || this.dataFromCreatePage.document_status === 'Y')){
                this.clearDataBudget()
            }
            const foundBudget = this.saveBudget.find(e => e.type_budget === this.saveBudgetData.type_budget);
            this.saveBudgetId = foundBudget ? foundBudget._id : null;
            if(this.saveBudgetId){
                this.getSumItemPrice()
                this.getSaveBudgetDetail(this.saveBudgetId)
            }else{

                this.getSumItemPrice()
                this.getGroupBudget(0)
            }
                
        },
        getSumItemPrice() {
            this.sumItemPrice = this.saveBudgetData.net 
            this.beforeSumItemPrice = this.saveBudgetData.net
        },
        clearDataBudget(){
            this.saveBudgetData.external_cost_to = ''
            this.saveBudgetData.sub_team = ''
            this.saveBudgetData.ref_po   = ''
            this.saveBudgetData.remark = ''
        },

        async getGroupBudget(key, groupId = null, index = 0) {
            if (key === 0) {
                for (let i = 0; i < this.saveBudgetData.item.length; i++) {
                    const tempGroup = {
                        "level"          : null,
                        "group"          : null,
                        // "group_id"       : null,
                        // "group_name"     : null,
                        "loading_status" : false,
                        "dropdown_list"  : [],
                    }
                    this.saveBudgetData.item[i].group = []
                    this.saveBudgetData.item[i].plan  = []

                    this.saveBudgetData.item[i].currency_exchange ||= "1";

                    this.saveBudgetData.item[i].discount = this.saveBudgetData.item[i].discount ? MainFunction.addComma(Number(this.saveBudgetData.item[i].discount?.replace(/,/g, '') * Number(this.saveBudgetData.item[i].currency_exchange?.replace(/,/g, ''))).toFixed(2)) : '0.00'
                    this.saveBudgetData.item[i].total_product_price = ((Number(this.saveBudgetData.item[i].total_product_price?.replace(/,/g, '')) * Number(this.saveBudgetData.item[i].currency_exchange?.replace(/,/g, ''))).toFixed(2) || '0.00').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0.00'
                    this.saveBudgetData.item[i].net = MainFunction.addComma(((Number(this.saveBudgetData.item[i].qt_value?.replace(/,/g, '') || this.saveBudgetData.item[i].total_product_price?.replace(/,/g, '') || 0)) - Number(this.saveBudgetData.item[i].discount?.replace(/,/g, ''))).toFixed(2) || '0.00')

                    for (let j = 0; j <= 3; j++) {
                        this.saveBudgetData.item[i].group.push({ 
                            ...tempGroup,
                            "level"          : j,
                            "loading_status" : j === 0? true : false
                        }) 
                    }              
                }
            } else {
                const propsForClearData = {
                    '1' : ['1', '2', '3'],
                    '2' : ['2', '3'],
                    '3' : [],
                }
                if (!groupId) {
                    propsForClearData[key - 1].forEach((e, i) => {
                        if (i !== 0) {
                            this.saveBudgetData.item[index].group[e].group = null
                            this.saveBudgetData.item[index].group[e].dropdown_list = []
                        }
                    })
                    this.$forceUpdate()
                    return
                } else {
                    propsForClearData[key].forEach(e => {
                        this.saveBudgetData.item[index].group[e].group         = null
                        this.saveBudgetData.item[index].group[e].dropdown_list = []
                    })
                    this.saveBudgetData.item[index].group[key].loading_status = true
                }
            }
            this.$forceUpdate()
            this.disabledBtnBudget  = false;
            try {
                let { data } = await this.axios.post(`${this.$api_url}/group_budget/api/v1/get_group_budget`, {
                    "tax_id"           : this.dataFromCreatePage.tax_id || null,
                    "budget_type"      : [ this.saveBudgetData.type_budget ] || null,
                    "upper_group_id"   : groupId || [],
                    "first_year"       : this.year_selected_start,
                    "last_year"        : this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end,
                })
                if (data.status && data.data.length) {
                    // for (let i = 0; i < data.data.length; i++) {
                    //     data.data[i].group_id = data.data[i].group_id
                    //     delete data.data[i]._id
                    // }
                    if (key === 0) {
                        for (let i = 0; i < this.saveBudgetData.item.length; i++) {
                            this.saveBudgetData.item[i].group[0].dropdown_list = data.data
                        }
                    } else {
                        this.saveBudgetData.item[index].group[key].dropdown_list = data.data
                        // this.saveBudgetData.item[index].group[key].dropdown_list.unshift({"_id": null, 'group_name': 'ไม่มี'})
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.disabledBtnBudget  = true;
                if (key === 0) {
                    for (let i = 0; i < this.saveBudgetData.item.length; i++) {
                        this.saveBudgetData.item[i].group[0].loading_status = false
                    }
                } else {
                    this.saveBudgetData.item[index].group[key].loading_status = false
                }
                this.$forceUpdate()
            }
        },
        calculateDateDiff() {
            if (!this.saveBudgetData.start_date || !this.saveBudgetData.end_date) {
                return
            }
            const tempStartDate = new Date(this.saveBudgetData.start_date);
            const tempEndDate = new Date(this.saveBudgetData.end_date);
            this.saveBudgetData.contract_term = Math.floor((tempEndDate.getTime() - tempStartDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
            this.saveBudgetData.budget_start_year = (Number(this.saveBudgetData.start_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
            this.saveBudgetData.budget_end_year = (Number(this.saveBudgetData.end_date?.split("-")[0] || '0') + 543).toString() || new Date().getFullYear() + 543
        },
        openPlanSaveBudgetModal(product, indexProduct) {
            if (!this.dataFromCreatePage.save_budget_id && this.dataFromCreatePage.document_status !== 'W') {
                return this.alert('ไม่พบข้อมูล Plan', 'Warning', 'info')
            }
            const tempData = {
                "index"                      : indexProduct,
                "end_date"                   : this.saveBudgetData?.end_date                       || null,
                "start_date"                 : this.saveBudgetData?.start_date                     || null,
                "saved_budget"               : product?.total_product_price                        || null ,
                "period"                     : product?.plan                                       || null,
                "save_budget_id"             : this.dataFromCreatePage?.save_budget_id             || null,
                "document_status"            : this.dataFromCreatePage?.document_status            || null,
                "document_status_permission" : this.dataFromCreatePage?.document_status_permission || null,
                "discount"                   : product?.discount                                   || null,
                "net"                        : product?.net                                        || null,
                "is_product_discount"        : this.isProductsDiscount                             || null
            }
            EventBus.$emit('planSaveBudgetModal', tempData)
        },
        async confirmAddSaveBudget() {
            this.isSubmitted = true;
            if(this.selectedBiz.tax_id === '0107544000094') {
                if (!this.dataFromCreatePage.save_budget_id && this.dataFromCreatePage.document_status !== 'W') {
                    return this.dialog = false
                }
                if (!this.$refs.saveBudgetForm.validate()) {
                    return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                }
                 for (let i = 0; i < this.saveBudgetData.item.length; i++) {
                    if (!this.saveBudgetData.item[i].plan.length) {
                        return this.alert('กรุณาบันทึก Plan ให้ครบทุกรายการ', 'Warning', 'info')
                    }
                }
                if (this.editDataMode) {
                    return this.editSaveBudgetAndPlanBudget()
                }
                if (this.dataFromCreatePage.save_budget_id && this.selectedBiz.tax_id === '0107544000094') {
                    let planUpdated = []
                    for (let i = 0; i < this.dataFromCreatePage.item.length; i++) {
                        for (let j = 0; j < this.dataFromCreatePage.item[i].plan.length; j++) {
                            if (!_.isEqual(this.dataFromCreatePage.item[i].plan[j], this.saveBudgetData.item[i].plan[j])) {
                                this.saveBudgetData.item[i].index = i
                                planUpdated.push(this.saveBudgetData.item[i])
                                j = this.dataFromCreatePage.item[i].plan.length
                            }
                        }
                    }
                    if (planUpdated.length) {
                        this.updatePlanSaveBudget(planUpdated)
                    } else {
                        this.dialog = false
                    }
                    return 
                }
            }
            if(this.selectedBiz.tax_id !== '0107544000094'){
                if (!this.saveBudgetStatus && this.dataFromCreatePage.document_status !== 'W') {
                    return this.dialog = false
                }
                if (!this.$refs.saveBudgetForm.validate()) {
                    return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                }
                for (let i = 0; i < this.saveBudgetData.item.length; i++) {
                    if (!this.saveBudgetData.item[i].plan.length) {
                        return this.alert('กรุณาบันทึก Plan ให้ครบทุกรายการ', 'Warning', 'info')
                    }
                }
                if (this.editDataMode) {
                    return this.editSaveBudgetAndPlanBudget()
                }
                if (this.saveBudgetStatus) {
                    let planUpdated = []
                    for (let i = 0; i < this.dataFromCreatePage.item.length; i++) {
                        for (let j = 0; j < this.dataFromCreatePage.item[i].plan.length; j++) {
                            if (!_.isEqual(this.dataFromCreatePage.item[i].plan[j], this.saveBudgetData.item[i].plan[j])) {
                                this.saveBudgetData.item[i].index = i
                                planUpdated.push(this.saveBudgetData.item[i])
                                j = this.dataFromCreatePage.item[i].plan.length
                            }
                        }
                    }
                    if (planUpdated.length) {
                        this.updatePlanSaveBudget(planUpdated)
                    } else {
                        this.dialog = false
                    }
                    return 
                }
            }
            let BizDataSaveBudgetData;
                if (this.selectedBiz.tax_id === '0107544000094'){
                    BizDataSaveBudgetData = { ...this.saveBudgetData };
                } else {
                    const { _id, ...rest } = this.saveBudgetData;
                    BizDataSaveBudgetData = { ...rest };
                }

            let addSaveBudgetBody = {
                ...BizDataSaveBudgetData,
                budget_end_year   : this.saveBudgetData.budget_end_year - 543           || null,
                budget_start_year : this.saveBudgetData.budget_start_year - 543         || null,
                total_budget      : this.saveBudgetData.total_budget?.replace(/,/g, '') || '0.00',
                saved_budget      : this.saveBudgetData.saved_budget?.replace(/,/g, '') || '0.00',
                discount          : this.saveBudgetData.discount?.replace(/,/g, '')     || '0.00',
                net               : this.saveBudgetData.net?.replace(/,/g, '')          || '0.00',
                from              : this.saveBudgetData.from                            || null,
                has_license       : typeof this.saveBudgetData.has_license   === 'boolean' ? this.saveBudgetData.has_license : null,
                license           : this.saveBudgetData.has_license === true ? this.saveBudgetData.license : null,
                renew             : typeof this.saveBudgetData.renew  === 'boolean' ? this.saveBudgetData.renew : null,
                serial_number     : this.saveBudgetData.serial_number || null,
                item              : this.saveBudgetData.item.map(e => {
                    return {
                        "plan"       : e?.plan                                                            || null,
                        "item_id"    : e?.item_id                                                         || null,
                        "item_name"  : e?.item_name                                                       || null,
                        "item_price" : e?.total_product_price?.replace(/,/g, '')                           || 0.00,
                        "discount"   : e?.discount?.replace(/,/g, '')                                      || '0.00',
                        "net"        : e?.net?.replace(/,/g, '')                                           || '0.00',
                        "group"      : e?.group?.map(e1 => (e1?.group && e1.group?.group_id?.length) && { ...e1?.group }).filter(Boolean) || null,
                        "_id"        : e?._id                                                             || null
                    }
                }),
                budget_year_type : this.type_year_selected,
                group_first_year : this.year_selected_start,
                group_last_year  : this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end
            }
            delete addSaveBudgetBody.save_budget_id
            try {
                this.loadingAddSaveBudget = true
                const { data } = await this.axios.post(`${this.$api_url}/save_budget/api/v1/add_save_budget`, addSaveBudgetBody)
                if (data.status) {
                    if (data.message === 'insufficient plan balance') {
                        return this.alert('งบประมาณไม่เพียงพอ', 'Warning', 'info')
                    }
                    this.dialog = false
                    this.alert('บันทึกงบประมาณสำเร็จ', 'Success', 'success')
                    EventBus.$emit('afterSaveBudget', data.data._id || null)
                }
            } catch (error) {
                console.log(error);
                this.alert('บันทึกงบประมาณไม่สำเร็จ', 'Fail', 'error')
            } finally {
                this.loadingAddSaveBudget = false
            }
        },
        cutItemName(name) {
            if (name.length > 13) {
                return `${name.substring(0, 13)}...`
            } else {
                return name
            }
        },
        updatePlanBudget(tempData = {}) {
            const index = tempData.index;
            this.$set(this.saveBudgetData.item[index],'is_plan_empty',tempData.is_plan_empty);
            if (!Object.keys(tempData).length === 2) {
                return
            }
            this.saveBudgetData.item[tempData.index].plan = tempData.period
            this.saveBudgetData.item[tempData.index].net =  tempData.net
            this.saveBudgetData.item[tempData.index].discount = tempData.discount
            this.saveBudgetData.discount = MainFunction.addComma(this.saveBudgetData.item.reduce((total, next) => total + Number(next.discount.replace(/,/g, '')) , 0).toFixed(2))
            this.saveBudgetData.net = MainFunction.addComma(this.saveBudgetData.item.reduce((total, next) => total + Number(next.net.replace(/,/g, '')), 0).toFixed(2))
        },
        async updatePlanSaveBudget(params) {
            if (!params?.length) {
                return
            }
            try {
                this.loadingAddSaveBudget = true
                let tempPromise = []
                for (let i = 0; i < params.length; i++) {
                    tempPromise.push({
                        method  : 'PUT',
                        baseURL : this.$api_url,
                        url     : `/save_budget/api/v1/edit_plan_save_budget/${this.dataFromCreatePage?.save_budget_id || null}`,
                        data    : {
                            "index": params[i].index,
                            "plan": params[i].plan,
                            "discount": params[i].discount.replace(/,/g, ''),
                            "net": params[i].net.replace(/,/g, ''),
                            "group_first_year" : this.year_selected_start,
                            "group_last_year"  : this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end
                        }
                    })
                }
                const data = await Promise.all(tempPromise.map(e => this.axios(e)))
                if (data.some(e => e.data.status)) {
                    this.dialog = false
                    this.alert('แก้ไขงบประมาณสำเร็จ', 'Success', 'success')
                } else {
                    this.alert('แก้ไขงบประมาณไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                console.log(error)
                this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
            } finally {
                this.loadingAddSaveBudget = false
            }
        },
        editGroupData() {
            this.isReady = false
            if (!this.editDataMode && !this.allGroupBudget?.length) {
                this.loadAllGroupBudget()
            }
            this.editDataMode = !this.editDataMode
            this.$nextTick(() => {
                this.isReady = true
            })
        },
        async loadAllGroupBudget() {
            try {
                this.loadingState = true;
                const config = this.saveBudgetData.item.map(e => {
                    return {
                        method: 'POST',
                        baseURL: this.$api_url,
                        url: '/group_budget/api/v1/get_all_group_budget',
                        data: {
                            "tax_id": this.dataFromCreatePage.tax_id || '',
                            "budget_type": this.selectedBiz.tax_id === '0107544000094' ? this.dataFromCreatePage.type_budget : this.saveBudgetData.type_budget,
                            "sub1": e.group[0]?.group_id || null,
                            "sub2": e.group[1]?.group_id || null,
                            "sub3": e.group[2]?.group_id || null,
                            "first_year": this.year_selected_start,
                            "last_year": this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end
                        },
                    };
                });
                
                const data = await Promise.allSettled(config.map(conf => this.axios(conf)));
                data.forEach((items, indexItems) => {
                    if (items.status ===  "fulfilled" && Object.keys(items.value.data.data).length) {
                        let groupEmptyIndex = null
                        this.saveBudgetData.item[indexItems].group = this.saveBudgetData.item[indexItems].group.map((groups, indexGroups) => {
                            let dropdownListTemp = indexGroups === 0 ? items.value.data.data['group'] : items.value.data.data[`sub${indexGroups}`]
                            if (groupEmptyIndex === null && !groups.group_id) {
                                groupEmptyIndex = indexGroups
                            }

                            return {
                                group_id: groups.group_id,
                                group_name: groups.group_name,
                                level: indexGroups,
                                loading_status: false,
                                group: {
                                    level: indexGroups,
                                    group_id: groups.group_id,
                                    group_name: groups.group_name,
                                },
                                dropdown_list: [
                                    // {    _id: null,
                                    //     group_name: 'ไม่มี'
                                    // },
                                    ...dropdownListTemp.map(list => {
                                        return {
                                            group_id: list.group_id,
                                            group_name: list.group_name,
                                            level: indexGroups,
                                        }
                                    })
                                ]
                            };
                        });
                        this.$nextTick(() => {
                            this.getGroupBudget(groupEmptyIndex, this.saveBudgetData.item[indexItems].group[groupEmptyIndex - 1].group_id, indexItems);
                            this.editDataMode = true
                        });
                    }
                });
            } catch (error) {
                this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                console.log(error);
                this.editDataMode = false
            } finally {
                this.loadingState = false;
            }
        },
        // async loadAllGroupBudget() {
        //     try {
        //         this.loadingState = true
        //         const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/search_group_budget?tax_id=${this.dataFromCreatePage.tax_id || ''}&budget_type=${this.dataFromCreatePage.type_budget || ''}&type=plan&year=${this.documentYear}`)
        //         if (data.status && Object.keys(data.data).length) {
        //             this.allGroupBudget = data.data.group_budget
        //             for (let i = 0; i < this.saveBudgetData.item.length; i++) {
        //                 for (let j = 0; j < this.saveBudgetData.item[i].group.length; j++) {
        //                     this.saveBudgetData.item[i].group[j].group          = null
        //                     this.saveBudgetData.item[i].group[j].loading_status = false
        //                     this.saveBudgetData.item[i].group[j].dropdown_list  = []
        //                     if (this.saveBudgetData.item[i].group[j].group_id) {
        //                         if (j === 0) {
        //                             var findGroupForGetDropdown = data.data.group_budget
        //                         } else {
        //                             this.saveBudgetData.item[i].group[j].dropdown_list.push({ "_id": null, 'group_name': 'ไม่มี' })
        //                             var findGroupForGetDropdown = this.saveBudgetData.item[i].group[j - 1].dropdown_list.find(e => e.group_id === this.saveBudgetData.item[i].group[j - 1].group.group_id)?.group_budget || []
                                
        //                         }
        //                         for (let k = 0; k < findGroupForGetDropdown.length; k++) {
        //                             const tempDropdownBudget = {
        //                                 level        : this.saveBudgetData.item[i].group[j].level,
        //                                 group_id     : findGroupForGetDropdown[k]._id           || null,
        //                                 group_name   : findGroupForGetDropdown[k]?.group_name   || null,
        //                                 group_budget : findGroupForGetDropdown[k]?.group_budget || null
        //                             }
        //                             this.saveBudgetData.item[i].group[j].dropdown_list.push(tempDropdownBudget)
        //                         }
        //                         this.saveBudgetData.item[i].group[j].group = {
        //                             level      : this.saveBudgetData.item[i].group[j].level,
        //                             group_id   : this.saveBudgetData.item[i].group[j]?.group_id   || null,
        //                             group_name : this.saveBudgetData.item[i].group[j]?.group_name || null,
        //                         }
        //                     } else {
        //                         if (this.saveBudgetData.item[i].group[j - 1].group?.group_id) {
        //                             let findGroupForGetDropdown = this.saveBudgetData.item[i].group[j - 1].dropdown_list.find(e => e.group_id === this.saveBudgetData.item[i].group[j - 1]?.group.group_id).group_budget || []
        //                             findGroupForGetDropdown.unshift({"_id": null, 'group_name': 'ไม่มี'})
        //                             for (let k = 0; k < findGroupForGetDropdown.length; k++) {
        //                                 const tempDropdownBudget = {
        //                                     level        : this.saveBudgetData.item[i].group[j].level,
        //                                     group_id     : findGroupForGetDropdown[k]._id           || null,
        //                                     group_name   : findGroupForGetDropdown[k]?.group_name   || null,
        //                                     group_budget : findGroupForGetDropdown[k]?.group_budget || null
        //                                 }
        //                                 this.saveBudgetData.item[i].group[j].dropdown_list.push(tempDropdownBudget)
        //                             }
        //                         }
        //                     }
        //                     this.saveBudgetData.item[i].group[j].level = j
        //                 }
        //             }
        //             this.$nextTick(() => {
        //                 this.editDataMode = true
        //             })
        //         }
        //     } catch (error) {
        //         console.log(error);
        //         this.editDataMode = false
        //         this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
        //     } finally {
        //         this.loadingState = false
        //     }
        // },
        async editSaveBudgetAndPlanBudget() {
            try {
                this.loadingAddSaveBudget = true
                const temp_body = {
                    "ref_po"           : this.saveBudgetData?.ref_po           || null,
                    "remark"           : this.saveBudgetData?.remark           || null,
                    "sub_team"         : this.saveBudgetData?.sub_team         || null,
                    "external_cost_to" : this.saveBudgetData?.external_cost_to || null,
                    "discount"         : this.saveBudgetData?.discount?.replace(/,/g, '')          || null,
                    "net"              : this.saveBudgetData?.net?.replace(/,/g, '')               || null,
                    "has_license"      : typeof this.saveBudgetData.has_license   === 'boolean' ? this.saveBudgetData.has_license : null,
                    "license"          : this.saveBudgetData.has_license === true ? this.saveBudgetData.license : null,
                    "renew"      : typeof this.saveBudgetData.renew   === 'boolean' ? this.saveBudgetData.renew : null,
                    "serial_number"    : this.saveBudgetData.serial_number || null,
                    "item"             : this.saveBudgetData.item.map(e => {
                        return {
                            "plan"       : e?.plan       || null,
                            "item_id"    : e?.item_id    || null,
                            "item_name"  : e?.item_name  || null,
                            "item_price" : e?.item_price || null,
                            "discount"   : e?.discount.replace(/,/g, '')    || null,
                            "net"        : e?.net.replace(/,/g, '')        || null,
                            "group"      : e?.group?.map(e1 => (e1?.group && e1.group.group_id) && {
                                "group_id"   : e1.group?.group_id   || null,
                                "group_name" : e1.group?.group_name || null,
                                "level"      : e1.group?.level      || typeof e1.group?.level === 'number'? e1.group.level : null,
                            }).filter(Boolean) || null
                        }
                    }),
                    "budget_year_type"             : this.type_year_selected,
                    "group_first_year"             : this.year_selected_start,
                    "group_last_year"              : this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end
                }
                const { data } = await this.axios.put(`${this.$api_url}/save_budget/api/v1/edit_save_budget/${this.dataFromCreatePage.save_budget_id || ''}`, temp_body)
                if (data.status) {
                    if (data.message === 'insufficient plan balance') {
                        return this.alert('งบประมาณไม่เพียงพอ', 'Warning', 'info')
                    }
                    this.dialog = false
                    this.alert('แก้ไขงบประมาณสำเร็จ', 'Success', 'success')
                    EventBus.$emit('afterSaveBudget', null)
                }
            } catch (error) {
                console.log(error);
                this.alert('แก้ไขงบประมาณไม่สำเร็จ', 'Fail', 'error')
            } finally {
                this.loadingAddSaveBudget = false
            }
        },
            
        alert(title = '', text = '', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
        addComma(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        clearGroupBudget() {
            let getGroupBudget = [];
            this.saveBudgetData.item = this.saveBudgetData.item.map((items, indexItems) => {
                return {
                    ...items,
                    group: items.group.map((group, indexGroup) => {
                        if (indexGroup === 0) {
                            getGroupBudget.push({
                                key: 0,
                                groupId: null,
                                index: indexItems
                            })
                        }
                        return {
                            ...group,
                            dropdown_list: null,
                            group: null,
                            group_id: null,
                            group_name: null,
                        }
                    })
                };
            })
            this.$refs.saveBudgetForm?.resetValidation()
            getGroupBudget.forEach(({key, groupId, index}) => {
                this.getGroupBudget(key, groupId, index);
            });
        },
        getYearList() {
            const startYear = 2023; // This year has started the project.
            const currentYear = new Date().getFullYear();
            this.year_selected_start = currentYear.toString();
            this.year_selected_end = currentYear.toString();
            const result = Array.from({ length: currentYear - startYear + 1 }, (_, index) => (startYear + index).toString());
            this.$set(this.item_year, 'from', result);
            this.$set(this.item_year, 'to', result);
        },
        changeYearSelect(event) {
            if (this.editDataMode || !this.dataFromCreatePage.save_budget_id) {
                this.clearGroupBudget();
            }
            this.$set(this.item_year, 'to', this.item_year.from.slice(this.item_year.from.indexOf(event)));
        },
        // outsideToCloseModal() {
        //     if (
        //         ["/create_cs_po", "/create_cspo_wait_qt"].includes(
        //             window.location.pathname
        //         )
        //     ) {
        //         EventBus.$emit("afterSaveBudget");
        //     }
        // },
        outsideToCloseModal() {
            if (this.$route.path !== "/all_document_cs_po" && this.$route.path !== "/inbox/purchase_detail") {
                return;
            }
                this.dialog = false;
        },
        getBudgetType(){
            let ListBudgetType = this.setTypeBudget.map(e =>{
                let firstCutBudgetType = '';
                if(e == 'ค่าใช้จ่ายขายและบริการ (SG&A)'){
                    firstCutBudgetType = 'SGA'
                }else if (e == 'ต้นทุนขาย (COGS)') {
                    firstCutBudgetType = 'COST'
                }else if (e == 'ต้นทุนวิจัยและพัฒนา (R&D)') {
                    firstCutBudgetType = 'RD'  
                }else{
                    firstCutBudgetType = ''
                }
                return firstCutBudgetType
            })
                this.ListBudgetType = [...new Set(ListBudgetType)];
        }
    }
}
</script>

<style>
    .save-budget-modal {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 20px !important;
    }

    .check-box-in-budget-save-budget-modal {
        font-size: 13px;
        color: black;
    }

    .text-box-save-budget-modal .v-input__control .v-input__slot {
        min-height: auto;
        padding: 0px 8px !important;
        font-size: 13px;
    }

    .text-box-group-save-budget-modal .v-input__control .v-input__slot {
        min-height: auto;
        padding: 0px 4px !important;
        font-size: 13px;
    }

    .dropdown-group-save-budget-modal {
        border-radius: 0px;
        font-size: 13px;
    }

    .dropdown-group-save-budget-modal.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto;
    }

    .dropdown-group-save-budget-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        padding: 0 4px;
    }

    .dropdown-group-save-budget-modal .v-icon.v-icon {
        font-size: 15px;
    }

    .dropdown-group-save-budget-modal .v-input__icon {
        min-width: auto;
        width: auto;
    }
    
    .dropdown-group-save-budget-modal.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
        padding-top: 2px;
    }

    .dropdown-external-cost-save-budget-modal {
        border-radius: 5px;
        font-size: 13px;
    }

    .dropdown-external-cost-save-budget-modal.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto;
    }

    .dropdown-external-cost-save-budget-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        padding-left: 8px;
        padding-right: 0px;
    }

    .dropdown-external-cost-save-budget-modal .v-icon.v-icon {
        font-size: 15px;
    }

    .dropdown-external-cost-save-budget-modal .v-input__icon {
        min-width: auto;
        width: auto;
    }

    .calendar-btn-save-budget-modal {
        border-radius: 10px;
    }

    .calendar-btn-save-budget-modal:not(.v-btn--round).v-size--default {
        min-width: auto;
        box-shadow: none;
    }

    .item-group-budget-list-save-budget-modal {
        background-color: #E7E7E7;
        min-height: 28px;
        line-height: 28px;
        font-weight: 700;
        font-size: 13px;
    }

    .name-first-item-header-save-budget-modal {
        border-radius: 10px 0px 0px 10px;
    }

    .name-last-item-header-save-budget-modal {
        border-radius: 0px 10px 10px 0px;
    }

    .remark-textarea-save-budget-modal.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        padding: 0px;
    }

    .remark-textarea-save-budget-modal {
        line-height: 24px;
        font-size: 13px;
    }

    .remark-textarea-save-budget-modal > .v-input__control > .v-input__slot {
        min-height: 24px !important;
    }

    .theme--light.date-picker-save-budget-modal:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        color: #BDBDBD !important;
    }

    .download-report-modal-date-picker .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .date-picker-save-budget-modal .v-input__control .v-input__slot .v-text-field__slot input {
        font-size: 13px;
    }

    .date-picker-save-budget-modal .v-input__control .v-input__slot .v-input__append-inner {
        padding-top: 14.5px;
    }

    .date-picker-save-budget-modal > .v-input__control > .v-input__slot {
        min-height: auto !important;
    }

    .date-picker-save-budget-modal .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 16px !important;
    }

    .date-picker-save-budget-modal .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .save-budget-modal-scroll {
        overflow-y: auto;
        border-radius: 0px;
        max-height: calc(100vh - 255px);
    }

    .save-budget-dropdown-select-year.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto !important;
        max-height: none;
    }

    .save-budget-dropdown-select-year .v-input__control .v-input__slot {
        padding-right: 5px !important;

    }
    
    .save-budget-dropdown-select-year {
        border-radius: 10px;
        font-size: 15px;
    }

    .list-dropdown .v-list {
        font-family: 'Noto Sans Thai', sans-serif;
    }
    .dropdown-external-save-budget-modal {
        border-radius: 5px;
        font-size: 13px;
    }

    .dropdown-external-save-budget-modal.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
        min-height: auto;
    }

    .dropdown-external-save-budget-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        padding-left: 8px;
        padding-right: 0px;
    }

    .dropdown-external-save-budget-modal .v-icon.v-icon {
        font-size: 13px;
    }

    .dropdown-external-save-budget-modal .v-input__icon {
        min-width: auto;
        width: auto;
    }

    .calendar-btn-error {
        background: linear-gradient(135deg, #FF0000, #CC0000) !important;
        border: 1px solid #B00000 !important;
        box-shadow: 0 2px 6px rgba(204, 0, 0, 0.35) !important;
    }

    .calendar-btn-success {
        background: linear-gradient(135deg, #00C853, #009624) !important;
        border: 1px solid #007A1F !important;
        box-shadow: 0 2px 6px rgba(0, 150, 36, 0.35) !important;
    }

    @media only screen and (max-width: 959px) {
        .name-first-item-header-save-budget-modal {
            border-radius: 10px 10px 0px 0px;
        }

        .name-last-item-header-save-budget-modal {
            border-radius: 0px 0px 0px 10px;
        }

        .calendar-btn-save-budget-modal {
            border-radius: 0px 0px 10px 0px;
        }
    }

    @media only screen and (max-width: 600px) {
        .save-budget-modal-scroll {
            max-height: calc(100vh - 350px);
        }
    }
</style>